import { render, staticRenderFns } from "./MarginEstimasi.vue?vue&type=template&id=7182852d&scoped=true"
import script from "./MarginEstimasi.vue?vue&type=script&lang=js"
export * from "./MarginEstimasi.vue?vue&type=script&lang=js"
import style0 from "./MarginEstimasi.vue?vue&type=style&index=0&id=7182852d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7182852d",
  null
  
)

export default component.exports